var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconLaughter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7998,
    cy: 16,
    r: 15.4074,
    fill: "#FFCC4F",
    stroke: "white",
    strokeWidth: 1.18519
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7998 6.51855C11.5727 6.51855 7.31836 10.7729 7.31836 16C7.31836 21.2272 11.5727 25.4815 16.7998 25.4815C22.027 25.4815 26.2813 21.2272 26.2813 16C26.2813 10.7729 22.027 6.51855 16.7998 6.51855Z",
    stroke: "#654A07",
    strokeWidth: 1.18519,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4883 16.437C10.4965 19.908 13.3245 22.7278 16.7997 22.7278C20.2748 22.7278 23.0987 19.908 23.111 16.437C23.111 16.437 20.4397 15.7527 16.7997 15.7527C13.1596 15.7527 10.4883 16.437 10.4883 16.437Z",
    stroke: "#654A07",
    strokeWidth: 1.18519,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8472 18.5107C11.6923 18.3293 13.9472 17.9047 16.7958 17.9047C19.6443 17.9047 21.9034 18.3293 22.7485 18.5107",
    stroke: "#654A07",
    strokeWidth: 1.18519,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9731 12.9536L19.3843 11.6633L21.9731 10.3689",
    stroke: "#654A07",
    strokeWidth: 1.18519,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.626 12.9536L14.2148 11.6633L11.626 10.3689",
    stroke: "#654A07",
    strokeWidth: 1.18519,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLaughter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconLaughter.92deaa3d.svg";
export { ForwardRef as ReactComponent };